module.exports = __webpack_public_path__ + "9970dcb8cde76c0d57887a3ec8017011.jpg";